// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0357f190","455":"089f7c92","977":"e8644d1a"}[chunkId] + ".chunk.js";
};